var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsers3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40.5,
    height: 40.5,
    viewBox: "0 0 40.5 40.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-users-3 1",
    clipPath: "url(#clip0_0_52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.25 18.5098C23.9634 18.5098 26.9736 15.4995 26.9736 11.7861C26.9736 8.07277 23.9634 5.0625 20.25 5.0625C16.5366 5.0625 13.5264 8.07277 13.5264 11.7861C13.5264 15.4995 16.5366 18.5098 20.25 18.5098Z",
    fill: "#8E94A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.72363 15.1875C9.51957 15.1875 11.7861 12.9209 11.7861 10.125C11.7861 7.32906 9.51957 5.0625 6.72363 5.0625C3.92769 5.0625 1.66113 7.32906 1.66113 10.125C1.66113 12.9209 3.92769 15.1875 6.72363 15.1875Z",
    fill: "#E2E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.7764 15.1875C36.5723 15.1875 38.8389 12.9209 38.8389 10.125C38.8389 7.32906 36.5723 5.0625 33.7764 5.0625C30.9804 5.0625 28.7139 7.32906 28.7139 10.125C28.7139 12.9209 30.9804 15.1875 33.7764 15.1875Z",
    fill: "#E2E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.125 28.6348C10.125 26.411 11.0084 24.2783 12.5808 22.7058C14.1533 21.1334 16.286 20.25 18.5098 20.25H21.9902C24.214 20.25 26.3467 21.1334 27.9192 22.7058C29.4916 24.2783 30.375 26.411 30.375 28.6348V30.375C30.375 31.7177 29.8416 33.0053 28.8922 33.9547C27.9428 34.9041 26.6552 35.4375 25.3125 35.4375H15.1875C13.8448 35.4375 12.5572 34.9041 11.6078 33.9547C10.6584 33.0053 10.125 31.7177 10.125 30.375V28.6348Z",
    fill: "#E2E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 21.9902C0 20.6266 0.541703 19.3188 1.50594 18.3546C2.47018 17.3903 3.77796 16.8486 5.1416 16.8486H8.62207C9.35149 16.8487 10.0692 17.0321 10.7092 17.3821C11.3491 17.7321 11.8909 18.2374 12.2845 18.8515C10.5721 19.8344 9.15843 21.2634 8.19394 22.9862C7.22946 24.709 6.75029 26.6612 6.80748 28.6348H3.24316C2.81727 28.6348 2.39554 28.5509 2.00206 28.3879C1.60858 28.2249 1.25106 27.986 0.949901 27.6849C0.648745 27.3837 0.409855 27.0262 0.246871 26.6327C0.0838869 26.2392 0 25.8175 0 25.3916L0 21.9902Z",
    fill: "#8E94A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.4999 21.9902C40.4999 20.6266 39.9582 19.3188 38.994 18.3546C38.0297 17.3903 36.722 16.8486 35.3583 16.8486H31.8779C31.1484 16.8487 30.4307 17.0321 29.7908 17.3821C29.1508 17.7321 28.6091 18.2374 28.2155 18.8515C29.9278 19.8344 31.3415 21.2634 32.306 22.9862C33.2705 24.709 33.7496 26.6612 33.6924 28.6348H37.2568C37.6827 28.6348 38.1044 28.5509 38.4979 28.3879C38.8913 28.2249 39.2489 27.986 39.55 27.6849C39.8512 27.3837 40.0901 27.0262 40.2531 26.6327C40.416 26.2392 40.4999 25.8175 40.4999 25.3916V21.9902Z",
    fill: "#8E94A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.5,
    height: 40.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers3);
export default __webpack_public_path__ + "static/media/icon-users-3.1b6c863de8b095152666c80af1d442c7.svg";
export { ForwardRef as ReactComponent };